import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

interface PublicRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  user?: boolean;
}

/**
 * If we have a logged-in user, redirect to the home page. Otherwise, display the component.
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ component: Component, user, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      user
        ? <Redirect to={{ pathname: '/' }} />
        : <Component user={user} {...props} />
    }
  />
);

export default PublicRoute;
